import DrawerBlockComponent from "../../../../uiKit/Drawer/components/DrawerBlockComponent"
import { Button, Checkbox, Form, Input, InputNumber, Select } from "antd"
import {
    CheckboxFormItem,
    formItemLayout8to16,
    formItemLayoutBalanced,
    renderInputNumberFormItem,
} from "../../_components/SettingFormItems"
import { InputOnOffCheckbox } from "./InputOnOffCheckbox"
import * as React from "react"
import { SettingFormItem } from "../../types"
import { WrappedFormUtils } from "antd/lib/form/Form"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { TimeSpan } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/hours_of_operation_v2"
import { CSSProperties } from "react"
import { numberToDollarsFormatter, numberToDollarsParser } from "../../../../../utils/formatters"
import OverrideNotification from "../../../../common/OverrideNotification"
import TwoRowsHeaderCell from "../../../../common/cells/TwoRowsHeaderCell"
import { FUTURE_ORDERING_DAYS_DEFAULT } from "./delivery/DeliveryFutureOrders"
import * as Color from "../../../../../constants/colors"
import { HooWarning } from "./HooWarning"

type Props = {
    pickupEnabled: boolean
    dineInEnabled: boolean
    pickupHoo: TimeSpan[]
    pickupHooModalOpen: boolean
    pickupHooActive: boolean
    isPickupFutureOrders: boolean
    curbsideEnabled: boolean
    isWebAndMobileOrderingEnabled: boolean
    acceptOnlyFutureOrderForPickup: boolean
    futurePickupDays: Maybe<number>
    defaultPickupTime: Maybe<number>
    leadTimeActivePickup: boolean
    settings: SettingFormItem
    form: WrappedFormUtils
    onStateValueChanged: (stateKey: string, value: Maybe<any>) => void
    onChangeCallback: () => void
}

export const PickupSettingsForm = (props: Props) => {
    const orderingType = props.dineInEnabled ? "Dine In" : "Pickup"
    const title = props.isWebAndMobileOrderingEnabled ? `${orderingType} (MIB + Mobile)` : orderingType

    const renderLeadTimeSettings = (activeKey: string, stateActiveKey: string, minutesKey: string) => {
        const leadTimeSettingMinutes =
            props.form.getFieldValue(minutesKey) != null
                ? props.form.getFieldValue(minutesKey)
                : props.settings[minutesKey]?.value
        const leadTimeHoursTotal = Math.floor(Number(leadTimeSettingMinutes) / 60)
        const leadTimeDaysInputValue = Math.floor(leadTimeHoursTotal / 24)
        const leadTimeHoursInputValue = leadTimeHoursTotal - leadTimeDaysInputValue * 24
        const leadTimeDisabled = !props.leadTimeActivePickup
        const settings = Object.assign({}, props.settings)
        const inputSuffixStyle = {
            pointerEvents: "none",
            fontSize: "13px",
            opacity: 0.75,
        }
        const errorMessage =
            !leadTimeDisabled && props.form.getFieldError(minutesKey) ? (
                <span>
                    Lead Time must be less than <b>Maximum Number of Days for Future Ordering</b>
                </span>
            ) : null
        const showDescMessage =
            !errorMessage && !leadTimeDisabled && (leadTimeHoursInputValue || leadTimeDaysInputValue)
        return (
            <Form.Item
                style={{
                    marginBottom: "0rem",
                    marginLeft: "4rem",
                    paddingTop: "18px",
                    paddingBottom: "2px",
                }}
                className="receipt-setting-form-item"
                label={
                    <TwoRowsHeaderCell
                        value="Require Lead Time"
                        subValue={
                            <span
                                style={{
                                    position: "absolute",
                                    top: "-1rem ",
                                }}>
                                Set lead time to give you ample time for preparation
                            </span>
                        }
                    />
                }
                {...formItemLayout8to16}>
                {props.form.getFieldDecorator(minutesKey)(<span />)}
                <div
                    style={{
                        position: "relative",
                        top: "-2px",
                    }}>
                    <div
                        style={{
                            float: "right",
                            marginLeft: "1rem",
                        }}>
                        <Checkbox
                            onChange={e => {
                                props.onStateValueChanged(stateActiveKey, e.target.checked)

                                if (!e.target.checked) {
                                    props.form.setFields({
                                        [minutesKey]: {
                                            value: leadTimeSettingMinutes,
                                            errors: undefined,
                                        },
                                    })
                                } else {
                                    const maxFutureDays = props.futurePickupDays
                                    const leadTimeMinutes =
                                        props.form.getFieldValue(minutesKey) || props.settings[minutesKey]?.value
                                    const leadTimeMinutesValue = Number(leadTimeMinutes)
                                    const leadTimeDays = leadTimeMinutesValue / 60 / 24
                                    // @ts-expect-error
                                    const maxLeadTimeDays = maxFutureDays + 1
                                    props.form.setFields({
                                        [minutesKey]: {
                                            value: leadTimeMinutes,
                                            errors: leadTimeDays >= maxLeadTimeDays ? [new Error("")] : undefined,
                                        },
                                    })
                                }

                                if (settings[activeKey]) {
                                    settings[activeKey].indeterminate = false
                                }
                                props.onChangeCallback()
                            }}
                            indeterminate={settings[activeKey]?.indeterminate}
                            checked={
                                settings[activeKey]?.indeterminate === true ? undefined : props.leadTimeActivePickup
                            }
                        />
                    </div>
                    <div
                        style={{
                            float: "right",
                            marginLeft: "0.5rem",
                        }}>
                        <Input
                            className="lead-time-input lead-time-hours-input"
                            style={{
                                width: "4.75rem",
                                marginRight: 0,
                                opacity: leadTimeDisabled ? 0.5 : 1,
                                pointerEvents: leadTimeDisabled ? "none" : "all",
                            }}
                            min={0}
                            max={24}
                            type="tel"
                            pattern="[0-9]*"
                            onFocus={e => e.target.select()}
                            value={leadTimeHoursInputValue}
                            suffix={
                                // @ts-expect-error
                                <span className="ant-input-suffix" style={inputSuffixStyle}>
                                    Hours
                                </span>
                            }
                            onChange={e => {
                                const value = Number(e.target.value) || 0
                                const newValue = value * 60 + leadTimeDaysInputValue * 24 * 60
                                const leadTimeDays = newValue / 60 / 24
                                const maxDays = (props.futurePickupDays || 0) + 1
                                props.form.setFields({
                                    [minutesKey]: {
                                        value: newValue,
                                        errors:
                                            !leadTimeDisabled && leadTimeDays >= maxDays ? [new Error("")] : undefined,
                                    },
                                })
                                props.onChangeCallback()
                            }}
                            placeholder={props.settings[minutesKey]?.indeterminate ? "Multiple values" : "minutes"}
                        />
                    </div>
                    <div
                        style={{
                            float: "right",
                        }}>
                        <Input
                            className="lead-time-input lead-time-days-input"
                            style={{
                                width: "4.75rem",
                                marginRight: 0,
                                opacity: leadTimeDisabled ? 0.5 : 1,
                                pointerEvents: leadTimeDisabled ? "none" : "all",
                            }}
                            min={0}
                            max={365}
                            type="tel"
                            pattern="[0-9]*"
                            onFocus={e => e.target.select()}
                            value={leadTimeDaysInputValue}
                            suffix={
                                // @ts-expect-error
                                <span className="ant-input-suffix" style={inputSuffixStyle}>
                                    Days
                                </span>
                            }
                            onChange={e => {
                                const value = Number(e.target.value) || 0
                                const newValue = leadTimeHoursInputValue * 60 + value * 24 * 60
                                const leadTimeDays = newValue / 60 / 24
                                const maxDays = (props.futurePickupDays || 0) + 1
                                props.form.setFields({
                                    [minutesKey]: {
                                        value: newValue,
                                        errors:
                                            !leadTimeDisabled && leadTimeDays >= maxDays ? [new Error("")] : undefined,
                                    },
                                })
                                props.onChangeCallback()
                            }}
                            placeholder={
                                props.settings[minutesKey] && props.settings[minutesKey].indeterminate
                                    ? "Multiple values"
                                    : "minutes"
                            }
                        />
                    </div>
                    <div
                        style={{
                            color: Color.Grey6,
                            clear: "both",
                            fontSize: "13px",
                            visibility: showDescMessage ? "visible" : "hidden",
                            height: showDescMessage ? "auto" : "16px",
                        }}>
                        You require your customers to order ahead by{" "}
                        <b>{`${leadTimeDaysInputValue ? leadTimeDaysInputValue + " days" : ""}${
                            leadTimeDaysInputValue && leadTimeHoursInputValue ? " and " : ""
                        }${leadTimeHoursInputValue ? leadTimeHoursInputValue + " hours" : ""}.`}</b>
                    </div>
                    {errorMessage && (
                        <div
                            style={{
                                color: Color.Red,
                                clear: "both",
                                fontSize: "13px",
                                position: "relative",
                                top: "-14px",
                                height: "16px",
                            }}>
                            {errorMessage}
                        </div>
                    )}
                </div>
            </Form.Item>
        )
    }

    const renderAcceptPickupFutureOrders = () => {
        return (
            <div>
                <InputOnOffCheckbox
                    settings={props.settings}
                    key="MIB_IS_FUTURE_ORDER_PICKUP_VALUE"
                    stateKey="isPickupFutureOrders"
                    stateFieldValue={props.isPickupFutureOrders}
                    label="Accept Pickup Orders for Future"
                    onChangeCallback={props.onChangeCallback}
                    onStateValueChanged={props.onStateValueChanged}
                    className="receipt-setting-form-item"
                />
                {props.isPickupFutureOrders && (
                    <>
                        <InputOnOffCheckbox
                            settings={props.settings}
                            key="MIB_ACCEPT_ONLY_FUTURE_ORDER_FOR_PICKUP"
                            stateKey="acceptOnlyFutureOrderForPickup"
                            stateFieldValue={props.acceptOnlyFutureOrderForPickup}
                            label="Only Accept Future Orders"
                            helperText="Require your customers to set a time/date to be able to place an order"
                            onChangeCallback={props.onChangeCallback}
                            onStateValueChanged={props.onStateValueChanged}
                            className="receipt-setting-form-item"
                            style={{
                                marginLeft: "4rem",
                            }}
                            helperTextStyle={{
                                marginLeft: "3rem",
                            }}
                        />
                        {renderLeadTimeSettings(
                            "MIB_FUTURE_ORDER_LEAD_TIME_ACTIVE_PICKUP",
                            "leadTimeActivePickup",
                            "MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_PICKUP"
                        )}
                        <Form.Item
                            style={{
                                marginBottom: "0.5rem",
                                marginLeft: "4rem",
                                paddingTop: "1rem",
                            }}
                            className="receipt-setting-form-item"
                            label={
                                <TwoRowsHeaderCell
                                    value="Set a Maximum Number of Days for Future Ordering"
                                    subValue={
                                        <span
                                            style={{
                                                position: "absolute",
                                                top: "-1rem ",
                                            }}>
                                            0 = Only for later today, 1 = Up to tomorrow, etc.
                                        </span>
                                    }
                                />
                            }
                            {...formItemLayoutBalanced}>
                            <InputNumber
                                key="price-input"
                                style={{
                                    textAlign: "right",
                                    width: "12rem",
                                }}
                                placeholder="7"
                                min={0}
                                max={30}
                                onBlur={e => {
                                    // @ts-expect-error
                                    const newMaxFutureDays = Math.round(e.target.value || FUTURE_ORDERING_DAYS_DEFAULT)
                                    props.onStateValueChanged("futurePickupDays", newMaxFutureDays)
                                    const leadTimeSettingMinutes =
                                        props.form.getFieldValue("MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_PICKUP") ||
                                        props.settings.MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_PICKUP.value
                                    const leadTimeDeliveryMinutesValue = Number(leadTimeSettingMinutes)
                                    const leadTimeDays = leadTimeDeliveryMinutesValue / 60 / 24
                                    const maxLeadTimeDays = newMaxFutureDays + 1
                                    props.form.setFields({
                                        MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_PICKUP: {
                                            value: leadTimeSettingMinutes,
                                            errors:
                                                props.leadTimeActivePickup && leadTimeDays >= maxLeadTimeDays
                                                    ? [new Error("")]
                                                    : undefined,
                                        },
                                    })
                                }}
                                step={1}
                                value={props.futurePickupDays || undefined}
                                onChange={val => {
                                    props.onStateValueChanged("futurePickupDays", val)
                                    props.onChangeCallback()
                                }}
                                onFocus={e => e.target.select()}
                            />
                        </Form.Item>
                    </>
                )}
            </div>
        )
    }

    const getDefaultDeliveryPickupTimeValues = (currentValue: Maybe<number>) => {
        const minutes = [0, 10, 15, 20, 25, 30, 40, 50, 60]

        // @ts-expect-error
        if (!minutes.includes(currentValue)) {
            // @ts-expect-error
            minutes.push(currentValue)
        }

        return minutes.map(v => {
            if (v === 0) {
                return (
                    <Select.Option key={v} value={0}>
                        0 Minutes (Immediate)
                    </Select.Option>
                )
            } else {
                return (
                    <Select.Option key={v} value={v}>
                        {v} Minutes
                    </Select.Option>
                )
            }
        })
    }

    const renderInputNumberCashSetting = (
        settingsParam: SettingFormItem,
        key: string,
        label: string,
        placeholder: string,
        form: WrappedFormUtils,
        style?: Maybe<Record<string, any>>
    ) => {
        const options = {
            initialValue:
                (settingsParam[key].value !== undefined && form.getFieldValue(key)
                    ? Number(form.getFieldValue(key))
                    : 0) || settingsParam[key].value
                    ? Number(settingsParam[key].value)
                    : undefined,
        }
        return (
            <Form.Item
                style={{
                    marginBottom: "0rem",
                    ...style,
                }}
                className="receipt-setting-form-item"
                {...formItemLayoutBalanced}
                label={`${label}`}>
                {form.getFieldDecorator(
                    key,
                    options
                )(
                    <InputNumber
                        key="price-input"
                        style={{
                            textAlign: "right",
                            width: "12rem",
                        }}
                        placeholder={settingsParam[key].indeterminate ? "Multiple values" : placeholder}
                        step={0.01}
                        onChange={() => props.onChangeCallback()}
                        formatter={numberToDollarsFormatter}
                        onFocus={e => e.target.select()}
                        parser={numberToDollarsParser}
                    />
                )}
                {settingsParam[key].indeterminate && (
                    <OverrideNotification
                        style={{
                            float: "right",
                            position: "absolute",
                            bottom: "0rem",
                            right: "-1rem",
                        }}
                    />
                )}
            </Form.Item>
        )
    }

    return (
        <div>
            <DrawerBlockComponent
                title={title}
                showSwitch={!props.dineInEnabled}
                onSwitchChange={val => {
                    props.onChangeCallback()
                    props.onStateValueChanged("pickupEnabled", val)
                }}
                switchValue={props.pickupEnabled}
                style={{
                    padding: 0,
                    position: "relative",
                }}>
                {!props.pickupEnabled && (
                    <div
                        style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#FFF",
                            zIndex: "4",
                            opacity: "0.6",
                        }}
                    />
                )}

                <div>
                    <Form.Item
                        style={{
                            marginTop: "0.25rem",
                            marginBottom: "0rem",
                            borderTop: "none",
                        }}
                        className="receipt-setting-form-item"
                        {...formItemLayoutBalanced}
                        label={`Set Hours Of Operation for ${orderingType}`}>
                        <div
                            style={{
                                position: "relative",
                                top: "5px",
                            }}>
                            <Button
                                disabled={!props.pickupHooActive}
                                onClick={() => props.onStateValueChanged("pickupHooModalOpen", true)}
                                style={{
                                    marginRight: "1rem",
                                }}>
                                Modify
                            </Button>
                            <Checkbox
                                onChange={e => {
                                    props.onStateValueChanged("pickupHooActive", e.target.checked)
                                    props.onChangeCallback()
                                }}
                                checked={props.pickupHooActive}
                            />
                        </div>
                    </Form.Item>
                    <div style={styles.labelHelpText}>
                        If not active, Location Hours Of Operation are used as default{" "}
                    </div>
                    <HooWarning
                        hooIsActive={props.pickupHooActive}
                        hooSpans={props.pickupHoo}
                        message="No hours have been set. Pickup will appear as closed to customers until hours are added."
                    />
                </div>

                {CheckboxFormItem(
                    props.settings,
                    "MIB_ACCEPT_CARD_FOR_PICKUP",
                    "Accept Online Card Payments",
                    props.form,
                    {},
                    props.onChangeCallback,
                    "receipt-setting-form-item",
                    "Customer will pay online, upon placing the order"
                )}
                {CheckboxFormItem(
                    props.settings,
                    "MIB_ACCEPT_CASH_FOR_PICKUP",
                    props.dineInEnabled ? "Accept Payments to Cashier" : "Accept Payments Upon Pickup",
                    props.form,
                    null,
                    props.onChangeCallback,
                    "receipt-setting-form-item",
                    props.dineInEnabled ? "Customer will pay directly to the cashier" : "Customer will pay upon pickup"
                )}
                {CheckboxFormItem(
                    props.settings,
                    "MIB_ACCEPT_TIPS_FOR_PICKUP",
                    "Accept Tips with Online Card Payments",
                    props.form,
                    null,
                    props.onChangeCallback,
                    "receipt-setting-form-item"
                )}
                {props.dineInEnabled &&
                    CheckboxFormItem(
                        props.settings,
                        "MIB_FORBID_COLLECT_EMAILS",
                        "Do Not Collect Emails",
                        props.form,
                        null,
                        props.onChangeCallback,
                        "receipt-setting-form-item"
                    )}

                {!props.dineInEnabled && (
                    <>
                        <div>
                            <Form.Item
                                style={{
                                    marginBottom: "0rem",
                                }}
                                className="receipt-setting-form-item"
                                {...formItemLayoutBalanced}
                                label={`Estimated Default ${orderingType} Time `}>
                                <Select
                                    defaultValue={props.defaultPickupTime}
                                    value={props.defaultPickupTime}
                                    onChange={value => {
                                        props.onStateValueChanged("defaultPickupTime", value || 0)
                                        props.onChangeCallback()
                                    }}
                                    style={{
                                        width: "12rem",
                                    }}>
                                    {getDefaultDeliveryPickupTimeValues(props.defaultPickupTime)}
                                </Select>
                            </Form.Item>
                        </div>
                        {renderInputNumberCashSetting(
                            props.settings,
                            "MIB_MIN_PICKUP_VALUE",
                            `Minimum value of Order for ${orderingType} ($)`,
                            "",
                            props.form
                        )}
                        {renderInputNumberFormItem(
                            props.settings,
                            "MIB_LAST_PICKUP_TIME",
                            `Last ${orderingType} Orders Before Closing Time (minutes)`,
                            "",
                            props.form,
                            null,
                            props.onChangeCallback,
                            "receipt-setting-form-item"
                        )}
                        {!props.dineInEnabled && renderAcceptPickupFutureOrders()}
                        <InputOnOffCheckbox
                            settings={props.settings}
                            key="MIB_PICKUP_CURBSIDE_OPTION_ENABLED"
                            stateKey="curbsideEnabled"
                            stateFieldValue={props.curbsideEnabled}
                            label={`Enable option for 'Curbside ${orderingType}'`}
                            onChangeCallback={props.onChangeCallback}
                            onStateValueChanged={props.onStateValueChanged}
                            className="receipt-setting-form-item"
                        />
                        {props.curbsideEnabled &&
                            CheckboxFormItem(
                                props.settings,
                                "MIB_PICKUP_CURBSIDE_OPTION_GUIDANCE",
                                `Request guidance for easier identification of ${orderingType}`,
                                props.form,
                                {
                                    marginLeft: "4rem",
                                },
                                props.onChangeCallback,
                                "receipt-setting-form-item",
                                `Inquires details for ${orderingType} (Vehicle color, licence plate number, etc.)`,
                                false,
                                null,
                                null,
                                {
                                    position: "relative",
                                    left: "3rem",
                                }
                            )}
                    </>
                )}
            </DrawerBlockComponent>
        </div>
    )
}

const styles: Record<string, CSSProperties> = {
    labelHelpText: {
        position: "relative",
        bottom: "14px",
        paddingLeft: "1rem",
        lineHeight: "1.3",
        fontSize: "12px",
        color: "#7E7E7E",
    },
}
